import React from 'react';
import styled from 'styled-components'

export default function RadioButton({ selected }){
    if (selected) return (
        <SelectedRadio>

        </SelectedRadio>
    )
    return (
        <Radio>

        </Radio>
    )
}

const Radio = styled.div`
    height: 10px;
    width: 10px;
    border-radius: 100%;
    background-color: white;
    border: solid 1px;
    margin-right: 10px;
`

const SelectedRadio = styled.div`
    margin-right: 10px;
    height: 10px;
    width: 10px;
    border-radius: 100%;
    background-color: black;
    border: solid 1px;
`

